"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
exports.default = (0, styles_1.styled)(material_1.Tabs)(function (_a) {
    var theme = _a.theme, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    return ({
        // set the indicator color
        '& .MuiTabs-indicator': {
            backgroundColor: size === 'small'
                ? theme.palette.primary.main
                : theme.palette.secondary.main,
        },
        ' & .MuiTab-root': __assign(__assign({ '&.Mui-selected': {
                color: size === 'small'
                    ? theme.palette.primary.main
                    : theme.palette.secondary.main,
            }, textTransform: 'none', color: size === 'small'
                ? theme.palette.primary[400]
                : theme.palette.common.white }, (size === 'small'
            ? theme.typography.bodyLarge
            : theme.typography.bodyXLarge)), { paddingLeft: 0, paddingRight: 0, marginRight: '40px', minWidth: '10px', '&:hover': {
                color: size === 'small'
                    ? theme.palette.primary.main
                    : theme.palette.secondary.main,
            } }),
    });
});
